import * as React from "react";
// react-bootstrap components
import { Button } from "react-bootstrap";

function CustomStatus({ value }) {
  let type = "danger";
  let title = "Major Issue";

  if (value !== null && value !== undefined && value < 1.5) {
    if (value < 0.5) {
      type = "success";
      title = "No Issue";
    } else {
      type = "warning";
      title = "Minor Issue";
    }
  } else if (value === null || value === undefined) {
    type = "help";
    title = "N/A";
  }
  return (
    <Button variant={type} className="btn-status">
      {title}
    </Button>
  );
}

export default CustomStatus;
